import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import { useAppStateContext } from 'src/AppState/AppState';
import { List } from 'react-movable';
import styled from '@emotion/styled';
import { EventMarketsItem } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketsItem/EventMarketsItem';
import { FilterTabs } from 'src/components/Filters/FilterTabs';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { CreateMarketModal } from 'src/domains/sportsbook/trading/view/eventDetails/markets/createMarketModal/CreateMarketModal';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { EventMarketsState } from './EventMarkets.state';
import {
    ButtonChangeInPlayForAll,
    ChangeInPlayPopup,
} from 'src/domains/sportsbook/trading/view/eventDetails/markets/MarketSettingsForm.style';

const ListElement = styled('li', { label: 'ListElement' })<{
    isDragged: boolean;
    isSelected: boolean;
}>`
    z-index: ${({ isDragged, isSelected }): string => (!isDragged && isSelected ? '1 !important' : '1000')};
    width: 100%;
    opacity: ${({ isDragged }): string => (isDragged === true ? '.5' : '1')};
    border-bottom: 1px solid #cfcfcf;
    background: rgba(255, 255, 255, 0.4);
    list-style: none;
    clear: both;
    display: flex;
    flex-wrap: nowrap;
`;

type EventMarketsPropsType = {
    eventId: EventId;
};

export const EventMarkets = observer('EventMarkets', (propsIn: EventMarketsPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [stateMap] = useState(
        () => new MobxMapAutoNew((eventId: EventId) => new EventMarketsState(eventId, appState))
    );
    const state = stateMap.get(props.eventId);

    const marketsAll = appState.sdkStaff.models.getEventMarketsAll(props.eventId.toOldId());

    if (marketsAll === null) {
        return (
            <div className='event-markets-no-markets'>
                <Loader isActive={true} />
                <div className='loading-message'>Loading...</div>
            </div>
        );
    }

    return (
        <div className='event-markets'>
            <ButtonChangeInPlayForAll onClick={state.openConfirmPopup}>
                Turn on inPlay in all Markets
            </ButtonChangeInPlayForAll>
            <a
                href='#'
                className='btn btn-add'
                onClick={state.onAddMarket}
            >
                Add market
            </a>
            <CreateMarketModal
                eventId={props.eventId}
                active={state.add}
                onClose={state.onCloseAddMarket}
                onFinish={state.onCloseAddMarket}
            />

            <FilterTabs
                available={state.getAvailableMarkets}
                active={state.filter}
                className='event-markets-filters'
                onChange={state.setFilter}
            />

            {Object.keys(state.marketGroups).length > 0 ? (
                <div className='event-markets-table form'>
                    <List
                        lockVertically
                        onChange={state.newOnSort}
                        renderList={({ children, props: ListProps, isDragged }) => (
                            <ul
                                {...ListProps}
                                className='flex-table'
                                style={{ cursor: isDragged ? 'grabbing' : 'inherit' }}
                            >
                                {children}
                            </ul>
                        )}
                        values={state.marketGroupsArray}
                        renderItem={({ value, props: itemProps, isDragged, index }) => {
                            if (index === undefined) {
                                return null;
                            }
                            const shortname = Object.keys(state.marketGroups)[index] ?? 'wrong-shortname';
                            const isSelected = state.openedMarket === value.id;

                            return (
                                <ListElement
                                    {...itemProps}
                                    className='rower ui-sortable-item form'
                                    isDragged={isDragged}
                                    isSelected={isSelected}
                                >
                                    <EventMarketsItem
                                        key={`${shortname}-new`}
                                        eventId={props.eventId}
                                        group={value.items}
                                        shortname={shortname}
                                        eventMarketsState={state}
                                    />
                                </ListElement>
                            );
                        }}
                    />
                </div>
            ) : (
                <div className='event-markets-no-markets'>No available markets.</div>
            )}
            {state.isConfirmPopupOpened === true ? (
                <ChangeInPlayPopup className='popup'>
                    <h3>Mark all markets as inplay</h3>
                    <div>
                        <button
                            className='btn'
                            onClick={state.cancelChangeMarketsInPlay}
                        >
                            Cancel
                        </button>
                        <button
                            className='btn'
                            onClick={state.setAllMarketsInPlay}
                        >
                            Confirm
                        </button>
                    </div>
                </ChangeInPlayPopup>
            ) : null}
        </div>
    );
});
